import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { freeBetStore } from '@pascal/pascal-core/shared/core/store';
import BetInput from './betInputSection';
import { soundService, soundTypes } from '../../../services';
import BetButtonSection from './betButtonSection/betButtonSection';
import { doBetStore } from '../../../store';

const BetSection = observer(
  ({
    t,
    onBlur,
    limits,
    onChange,
    betAmount,
    isBetsClosed,
    totalBetsAmount,
    showNotification,
    handleOpenNumPad,
    isLoadingBetButton,
    handleChangeInputValue,
  }) => {
    const [isValidatedAmount, setIsValidatedAmount] = useState(false);
    const { activeFreeBet } = freeBetStore;
    const decidedCallBackCall = (callback) => {
      if (isValidatedAmount) {
        setIsValidatedAmount(false);
      } else {
        soundService.play(soundTypes.clickButton);
        return callback();
      }
      return null;
    };
    useEffect(() => {
      if (activeFreeBet.id) {
        doBetStore.setBetAmount(activeFreeBet?.amount);
      } else {
        doBetStore.setBetAmount(limits.defaultBetAmount || limits.minBet);
      }
    }, [activeFreeBet]);
    return (
      <div className='monti-actions'>
        <BetInput
          t={t}
          limits={limits}
          onBlur={onBlur}
          onChange={onChange}
          betAmount={betAmount}
          activeFreeBet={activeFreeBet}
          handleOpenNumPad={handleOpenNumPad}
          showNotification={showNotification}
          setIsValidatedAmount={setIsValidatedAmount}
          handleChangeInputValue={handleChangeInputValue}
        />
        <BetButtonSection
          t={t}
          limits={limits}
          betAmount={betAmount}
          isBetsClosed={isBetsClosed}
          activeFreeBet={activeFreeBet}
          totalBetsAmount={totalBetsAmount}
          isLoadingBetButton={isLoadingBetButton}
          decidedCallBackCall={decidedCallBackCall}
        />
      </div>
    );
  }
);

export default BetSection;
